import React from 'react';
import { Flex } from '@chakra-ui/react';

export const Space = ({ ...rest }) => <Flex flex="1" {...rest} />;
